<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Create New Event & Tips Action</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  id="title"
                  label="Title"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Title"
                  @change="handleCorporateActionHashtagTitle"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <div role="group" class="form-group form-row mb-0">
                <label class="col-form-label col-sm-3">Page</label>
                <div class="col-sm-9">
                  <multiselect
                    horizontal
                    v-model="corporateActionHashtagData.corporate_action_hashtag_page_array"
                    :options="OptionPage"
                    :multiple="true"
                    placeholder="Select Page"
                  />
                </div>
              </div>
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton color="success" class="float-right" @click="createNewCorporateActionHashtag">Save</CButton>
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import Swal from "sweetalert2";
import jwt from "jsonwebtoken"
import Multiselect from 'vue-multiselect';

export default {
  name: "CorporateHashtagCreate",
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.usersOpened = from.fullPath.includes("usercreate");
    });
  },
  components: {
    Multiselect,
  },
  data() {
    return {
      corporateActionHashtagData: {
        corporate_action_hashtag_title: "",
        corporate_action_hashtag_page_array: [],
        corporate_action_hashtag_page: "",
        status: ""
      },
      OptionPage: ['Ongkir'],
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      optionsStatus: ["ACTIVE", "INACTIVE"],
      url: null,
    };
  },
  mounted() {
    this.authentication()
  },
  computed: {},
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
          data.account_group === "MARKETING" ||
          data.account_group === "ADMIN" ||
          data.account_group === "ADMINISTRATOR"
      ) {
        return null
      } else {
        this.$router.push({ path: `/` });
      }
    },
    goBack() {
      this.usersOpened
          ? this.$router.go(-1)
          : this.$router.push({ path: "/management/corporate-hashtag" });
    },
    handleCorporateActionHashtagTitle(event) {
      console.log(event)
      var hashtag = event.replaceAll(/[^A-Za-z0-9]/g,'').replaceAll('#','').replaceAll(' ','').replaceAll('--','').trim();
      document.getElementById('title').value = hashtag;
      this.corporateActionHashtagData.corporate_action_hashtag_title = hashtag;
    },
    createNewCorporateActionHashtag() {
      let formData = new FormData();
      formData.append("corporate_action_hashtag_title", this.corporateActionHashtagData.corporate_action_hashtag_title);
      if (this.corporateActionHashtagData.corporate_action_hashtag_page_array && this.corporateActionHashtagData.corporate_action_hashtag_page_array.length > 0) {
        const joined = this.corporateActionHashtagData.corporate_action_hashtag_page_array.join(',');
        formData.append("corporate_action_hashtag_page", joined);
      } else if (this.corporateActionHashtagData.corporate_action_hashtag_page) {
        formData.append("corporate_action_hashtag_page", this.corporateActionHashtagData.corporate_action_hashtag_page);
      }
      axios
          .post(`${this.domain}/v1/corporate_action_hashtag`, formData, {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json"
            }
          })
          .then(response => {
            // JSON responses are automatically parsed.
            Swal.fire({
              icon: "success",
              title: `Event & Tips Hashtag Data Created`,
              showConfirmButton: false,
              timer: 2000
            });
            this.items = response.data;
            this.$router.push({ path: `/management/corporate-hashtag` });
          })
          .catch(err => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.response.data.message.id
            });
            console.log(err);
          });
    },
    validator(val) {
      return val ? val.length >= 4 : false;
    }
  }
};
</script>

<style scoped>
@import "./CorporateHashtag.css";
</style>
